<template>
  <div class="mob-detail">
    <img class="top-banner" src="@/assets/img/banner.png" alt="" />
    <div class="content-box">
      <div class="info-top">
        <div class="info-title">{{obj.name}}</div>
        <div class="info-desc">{{obj.address}}</div>
        <div class="info-tab">
          <div class="info-left">备案证书编号：</div>
          <div class="info-right">{{obj.certificateNo}}</div>
        </div>
        <div class="info-tab">
          <div class="info-left">统一社会信用代码：</div>
          <div class="info-right">{{obj.creditCode}}</div>
        </div>
        <div class="info-tab">
          <div class="info-left">门店数量：</div>

          <div class="info-right">{{obj.storeNum}}</div>
        </div>
      </div>

      <div class="part-title">基本信息</div>
      <div class="tab-bottom">
        <div class="tab-lr">
          <div class="tab-lr-left">区县：</div>
          <div class="tab-lr-right">{{obj.districtName}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">工商注册时间：</div>
          <div class="tab-lr-right">{{obj.foundedDate}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">营业执照有效期：</div>
          <div class="tab-lr-right"></div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">经营范围：</div>
          <div class="tab-lr-right">{{obj.businessScope}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">企业类型：</div>
          <div class="tab-lr-right"></div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">注册资本：</div>
          <div class="tab-lr-right">{{obj.registeredCapital}}<span v-if="obj.registeredCapital">万元</span></div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">法人代表：</div>
          <div class="tab-lr-right">{{obj.charge}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">电子邮件：</div>
          <div class="tab-lr-right"></div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">联系人：</div>
          <div class="tab-lr-right">{{obj.contacts}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">联系电话：</div>
          <div class="tab-lr-right">{{obj.contactsPhone}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">企业地址：</div>
          <div class="tab-lr-right"> {{obj.address}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">企业简介：</div>
          <div class="tab-lr-right"> {{obj.profile}}</div>
        </div>
      </div>

      <div class="part-title">机构人员</div>
      <div class="tab-tb-top">
        <div style="flex: 1">姓名</div>
        <div style="flex: 1">联系电话</div>
        <div style="flex: 1">从业编码</div>
      </div>
      <div class="tab-tb-list">
        <div class="tab-tb-item" v-for="(item,index) in pList" :key="index">
          <div style="flex: 1">{{item.name}}</div>
          <div style="flex: 2">{{item.phoneNo}}</div>
          <div style="flex: 2">{{item.code}}</div>
        </div>
      </div>

      <div class="part-title">良好行为记录</div>
      <div class="tab-tb-top">
        <div style="flex: 1">获奖名称</div>
        <div style="flex: 1">获奖日期</div>
        <div style="flex: 1">证书编号</div>
        <div style="flex: 1">积分分值</div>
      </div>
      <div class="tab-tb-list">
        <div class="tab-tb-item" v-for="(item,index) in goodList" :key="index">
          <div style="flex: 1">{{item.title}}</div>
          <div style="flex: 1">{{item.recordDate}}</div>
          <div style="flex: 1"></div>
          <div style="flex: 1">{{item.points}}</div>
        </div>
      </div>

      <div class="part-title">不良行为记录</div>
      <div class="tab-tb-top">
        <div style="flex: 1">违规名称</div>
        <div style="flex: 1">违规内容</div>
        <div style="flex: 1">违规时间</div>
        <div style="flex: 1">扣分分值</div>
      </div>

      <div class="tab-tb-list">
        <div class="tab-tb-item"  v-for="(item,index) in badList" :key="index">
          <div style="flex: 1">{{item.title}}</div>
          <div style="flex: 1">{{item.remarks}}</div>
          <div style="flex: 1">{{item.recordDate}}</div>
          <div style="flex: 1">{{item.points}}</div>
        </div>
      </div>

      <div class="part-title">机构积分</div>
      <div class="tab-tb-top">
        <div style="flex: 1">开始日期</div>
        <div style="flex: 1">结束日期</div>
        <div style="flex: 1">总分</div>
      </div>
      <div class="tab-tb-list">
        <div class="tab-tb-item">
          <div style="flex: 1">{{obj.totalPoint && obj.totalPoint.start}}</div>
          <div style="flex: 1">{{obj.totalPoint && obj.totalPoint.end}}</div>
          <div style="flex: 1">{{obj.totalPoint && obj.totalPoint.totalPoint}}</div>
        </div>
      </div>

      <div class="part-title">机构网签地点</div>
      <div id="mapBox"></div>
    </div>

    <div class="footer">
      <p>主办单位: 山东省聊城市东昌府区</p>
      <p>创建时间:2021-11-11</p>
      <p>技术支持单位: 山东聊城</p>
    </div>
  </div>
</template>

<script>
import "@/assets/util/rem.js";
import { companyDetail, behavior } from "@/assets/api/company";
import { personList } from "@/assets/api/person";
export default {
  name: "mob-detail",
  components: {},

  data() {
    return {
      id: this.$route.query.id,
      goodList: [],
      badList: [],
      obj: "",
      pList: [],
    };
  },
  mounted() {
    this.getDetail();
    this.getBehaviorGood();
    this.getBehaviorBad();
    this.getPersonList();
  },
  methods: {
     initMap() {
      var map = new BMapGL.Map("mapBox");
      // 创建地图实例
      var point = new BMapGL.Point(this.obj.lng || 116.404, this.obj.lat || 39.915);
      map.centerAndZoom(point, 13);
      map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      if (this.obj.lng && this.obj.lat) {
        let point = new BMapGL.Point(this.obj.lng, this.obj.lat);
        let marker = new BMapGL.Marker(point); // 创建标注
        map.addOverlay(marker); // 将标注添加到地图中
                // 创建点坐标
        let obj = {
            title: this.obj.name,
            message: this.obj.address,
            Longitude: this.obj.lng,
            latitude: this.obj.lat,
            width: 200, // 信息窗口宽度
            height: 100, // 信息窗口高度
        }
        var infoWindow = new BMapGL.InfoWindow(this.obj.address, obj); // 创建信息窗口对象
        map.openInfoWindow(infoWindow, point); //开启信息窗口
        marker.addEventListener("onmouseover", function () {
          map.openInfoWindow(infoWindow, point); //开启信息窗口
        });
      }
    },
    async getDetail() {
      const res = await companyDetail({ id: this.id });
      if (res && res.data && res.data.code == 200) {
        this.obj = res.data.data;
        console.log(this.obj);
        this.initMap();

      }
    },
    async getBehaviorGood() {
      const res = await behavior({
        companyId: this.id,
        good: 1,
      });
      if (res && res.data && res.data.code == 200) {
        this.goodList = res.data.rows || [];
      }
    },
    async getBehaviorBad() {
      const res = await behavior({
        companyId: this.id,
        good: 0,
      });
      if (res && res.data && res.data.code == 200) {
        this.badList = res.data.rows || [];
      }
    },
    async getPersonList() {
      const res = await personList({
        companyId: this.id,
      });
      if (res && res.data && res.data.code == 200) {
        this.pList = res.data.rows || [];
        console.log(this.pList);
      }
    },
  },
  computed: {},
};
</script>

<style lang="less">
.mob-detail {
  width: 7.5rem;
  margin: 0 auto;
  background: rgb(229, 51, 51);
  min-height: 100vh;
  overflow: hidden;
  .top-banner {
    width: 100%;
    height: auto;
  }
  .content-box {
    width: 6.3rem;
    padding: 0.2rem;
    background: #fff;
    margin: 0.6rem auto 0;
    .info-top {
      border: 1px solid #eee;
      padding: 0.2rem;
      .info-title {
        font-size: 0.42rem;
        color: #222;
        font-weight: bold;
      }
      .info-desc {
        margin: 0.22rem 0;
        font-size: 0.28rem;
        color: #888;
      }
    }
    .info-tab {
      display: flex;
      margin-top: 0.12rem;
      align-items: flex-start;
      font-size: 0.28rem;
      color: #555;
      .info-left {
        flex-shrink: 0;
        width: 2rem;
        margin-right: 0.22rem;
      }
      .info-right {
        flex: 1;
      }
    }
    .part-title {
      font-size: 0.32rem;
      color: #444;
      margin: 0.64rem 0 0.24rem;
    }
    .tab-bottom {
      border-bottom: 1px solid #eee;
    }
    .tab-lr {
      border: 1px solid #eee;
      border-bottom: none;
      display: flex;
      font-size: 0.24rem;
      line-height: 1.6;
      .tab-lr-left {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.24rem;
        min-height: 0.42rem;
        background: #f5f5f5;
        color: #999;
        border-right: 1px solid #eee;
        word-wrap: break-word;
        word-break: break-all;
      }
      .tab-lr-right {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.24rem;
        min-height: 0.84rem;
        background: #fff;
        color: #222;
        word-wrap: break-word;
        word-break: break-all;
      }
    }

    .tab-tb-top {
      border: 1px solid #eee;
      display: flex;
      font-size: 0.24rem;
      line-height: 1.6;
      & > div {
        border-right: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.24rem;
        min-height: 0.42rem;
        background: #f5f5f5;
        color: #999;
        word-wrap: break-word;
        word-break: break-all;
        &:last-child {
          border-right: none;
        }
      }
    }
    .tab-tb-item {
      border: 1px solid #eee;
      border-top: none;
      display: flex;
      font-size: 0.24rem;
      line-height: 1.6;
      background: #fff;
      &:nth-of-type(2n) {
        background: #f5f5f5;
      }
      & > div {
        border-right: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.24rem;
        min-height: 0.42rem;
        color: #333;
        word-wrap: break-word;
        word-break: break-all;
        &:last-child {
          border-right: none;
        }
      }
    }
  }
  .footer {
    width: 7rem;
    margin: 0 auto;
    color: #fff;
    padding: 0.42rem 0;
    p {
      text-align: center;
      font-size: 0.24rem;
      color: #eee;
      margin: 0.12rem 0;
    }
  }
  #mapBox {
    width: 100%;
    height: 3rem;
  }
  .BMap_bubble_title {
    width: 180px!important;
     white-space: nowrap!important;
    text-overflow: ellipsis!important;
    overflow: hidden!important;
    word-break: break-all!important;
  }
}
</style>